import { App, Button, Col, Flex, Input, Modal, Popconfirm, Row, Select, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { API_ROUTE } from '../../../utils/commonConstants';
import { DELETE, GET, PUT } from '../../../utils/requestActionConstants';
import { fetcher, processReq } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { orderTabConfig } from '../OrdersTab';
import { useDispatch, useSelector } from 'react-redux';
import { setOrders, setOrder } from '../../../store/slices/orderSlice';
import SearchComponent from '../../../components/SearchComponent';
import { orderStatus, paymentStatus } from '../../../utils/configConstants';
import { FilePdfFilled } from '@ant-design/icons';
import PrintableInvoice from '../../../components/PrintableInvoice';
import CsvLink from 'react-csv-export';
import PDFListDownloader from '../../../components/PDFListDownloader';
import { formatNumber } from '../../../utils/formatters';
import { MdRefresh } from 'react-icons/md';
import ShippingLabel from '../../../components/ShippingLabel';

function AllOrders({ onSwitchTab }) {
  const { message, modal, notification } = App.useApp();
  const dataFetcher = useSWR({ method: GET, url: API_ROUTE + '/orders' }, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    refreshInterval: 0,
    dedupingInterval: Infinity, // never re-fetch
  });
  const [orderList, setOrderList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const dispatch = useDispatch();
  const [filteredData, setFilteredData] = useState([]);
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const [isShippingLabelModalOpen, setIsShippingLabelModalOpen] = useState(false);

  const edit = (data) => {
    dispatch(setOrder(data))
    onSwitchTab(orderTabConfig.ADD, data);
  }

  useEffect(() => {
    if (dataFetcher.data) {
      setOrderList(dataFetcher.data);
    }
  }, [dataFetcher?.data])

  const columns = [
    {
      title: 'Order Date',
      dataIndex: 'orderDate',
      key: 'orderDate',

    },
    {
      title: 'Customer',
      // dataIndex: 'billingName',
      // key: 'billingName',
      render: (_, record) => (
        <>
          <div className='flex gap-1'>
            {record.shipping?.firstName}
          </div>
        </>
      )
    },
    {
      title: 'Email',
      // dataIndex: 'billingEmail',
      // key: 'billingEmail',
      render: (_, record) => (
        <>
          <div className='flex gap-1'>
            {record.shipping?.email}
          </div>
        </>
      )
    },
    {
      title: 'Tracking Number',
      dataIndex: 'orderTrackingNumber',
      key: 'orderTrackingNumber',
    },
    {
      title: 'Amount (Rs)',
      dataIndex: 'total',
      key: 'total',
      // defaultSortOrder: 'descend',
      sorter: (a, b) => a.total - b.total,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      render: (_, record) => (
        <>
          <div className='flex gap-1'>
            {/* <Button onClick={() => edit(record)}>Amend</Button> */}
            <Button type="primary" onClick={() => {
              setSelectedOrder(record);
              setModalOpen(true)
            }}>Details</Button>
            {/* <Button danger type='link' onClick={() => {
              setSelectedOrder(record);
              setIsInvoiceModalOpen(true)
            }}><FilePdfFilled /></Button> */}
          </div>
        </>
      )
    }
  ];

  // const formatData = state.orderList?.map(dt => ({
  //     key: dt.id,
  //     email: dt.user?.email,
  //     orderDate: dayjs(dt.createdAt).format("YYYY-MM-DD"),
  //     customerName: dt.user?.name,
  //     ...dt
  //   }));

  const onDeleteOrder = async () => {
    const result = await processReq(DELETE, API_ROUTE + "/orders/delete/" + selectedOrder.id);

    if (result.order) {
      dataFetcher.mutate();
      setModalOpen(false);
      message.success(result.message);
    } else {
      message.error("Something went wrong " + result.message);
    }
  }

  const onFilter = (filteredData) => {
    setFilteredData(filteredData);
  }

  const onChangeOrderStatus = (status) => {
    setSelectedOrder({
      ...selectedOrder,
      status: status
    });
  }

  const onChangePaymentStatus = (status) => {
    let selectedOrderClone = JSON.parse(JSON.stringify(selectedOrder));

    if (selectedOrderClone.payment) {
      selectedOrderClone.payment.status = status;
    }

    setSelectedOrder(selectedOrderClone);
  }

  const onChangeShippingTrackingNumber = (event) => {
    let selectedOrderClone = JSON.parse(JSON.stringify(selectedOrder));

    if (selectedOrderClone.shipping) {
      selectedOrderClone.shipping.trackingNumber = event.target.value;
    }

    setSelectedOrder(selectedOrderClone);
  }

  const onSaveSelectedOrder = async () => {
    setIsSaving(true);

    const result = await processReq(PUT, API_ROUTE + "/orders/update/" + selectedOrder.id, {
      status: selectedOrder.status,
      shippingTrackingNumber: selectedOrder.shipping.trackingNumber,
      payment: selectedOrder.payment
    });

    setIsSaving(false);
    setModalOpen(false);

    message.success(result.message);
    dataFetcher.mutate();
  }

  const pdfDownloadColumns = [
    { key: "id", label: "ID" },
    { key: "orderDate", label: "Date" },
    { key: "customer", label: "Customer" },
    { key: "status", label: "Status" },
  ];

  return (
    <Row gutter={[16, 16]}>
      <Flex justify='space-between' className='w-full pr-3'>
        <SearchComponent masterData={orderList} onFilter={onFilter} filterByKeys={['orderDate', 'status', 'total', 'email', 'orderTrackingNumber', 'customerName']} />
        <Flex content='center'>
          <CsvLink data={filteredData} fileName="weda_arana_data" withTimeStamp>
            <div className='text-right text-lg'><Button>CSV</Button></div>
          </CsvLink>
          <PDFListDownloader records={filteredData} columns={pdfDownloadColumns} />
          <Button onClick={() => dataFetcher.mutate()}><MdRefresh /></Button>
        </Flex>
      </Flex>
      <Col span={24} className='overflow-x-auto'>
        <Table columns={columns} dataSource={filteredData} loading={dataFetcher.isValidating || dataFetcher.isLoading} />
      </Col>

      {selectedOrder.orderItems && <PrintableInvoice order={selectedOrder} isShow={isInvoiceModalOpen} setIsShow={setIsInvoiceModalOpen} />}

      {selectedOrder.id && (
        <Modal
          title={`${selectedOrder.orderDate} | ${selectedOrder.customerName} | ${selectedOrder.orderTrackingNumber}`}
          centered
          maskClosable={false}
          open={modalOpen}
          onOk={() => setModalOpen(false)}
          onCancel={() => setModalOpen(false)}
          styles={{ body: { maxHeight: "600px", overflowY: "auto", paddingRight: 5 } }}
          footer={() => {
            return (
              <div className='flex gap-1 justify-end'>
                <Button danger color='danger' onClick={() => setModalOpen(false)}>Close</Button>
                <Popconfirm title="Delete order" description="Are you sure to delete this order?" onConfirm={onDeleteOrder}
                  // onCancel={onDeleteOrder}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button danger type='primary'>Delete</Button>
                </Popconfirm>
                <Button type='primary' onClick={onSaveSelectedOrder} loading={isSaving}>Save & Close</Button>
              </div>
            )
          }}
        >
          <div className='font-bold p-1 bg-slate-100 border'>Customer Details</div>
          <div className='grid grid-cols-2 gap-2 p-3 border'>
            <div>Name</div><div>: {selectedOrder.billing.firstName}</div>
            <div>Email</div><div>: {selectedOrder.billing.email}</div>
          </div>

          <div className='font-bold p-1 bg-slate-100 mt-2 border'>Order Details</div>
          <div className='grid grid-cols-2 gap-2 p-3 border'>
            <div>ID</div><div>: {selectedOrder.id}</div>
            <div>Tracking Number</div><div>: {selectedOrder.orderTrackingNumber}</div>
            <div>Date</div><div>: {selectedOrder.orderDate}</div>
            <div>Total</div><div>: {selectedOrder.total}</div>
            <div>Status</div>
            <div>: <Select
              showSearch
              placeholder="Order Status"
              optionFilterProp="label"
              value={selectedOrder.status}
              onChange={onChangeOrderStatus}
              // onSearch={onSearch}
              options={[
                {
                  value: orderStatus.ORDER_PLACED,
                  label: orderStatus.ORDER_PLACED,
                },
                {
                  value: orderStatus.PROCESSING,
                  label: orderStatus.PROCESSING,
                },
                {
                  value: orderStatus.SHIPPED,
                  label: orderStatus.SHIPPED,
                },
                {
                  value: orderStatus.CANCELLED,
                  label: orderStatus.CANCELLED,
                },
                // {
                //   value: orderStatus.OUT_FOR_DELIVERY,
                //   label: orderStatus.OUT_FOR_DELIVERY,
                // },
                // {
                //   value: orderStatus.DELIVERED,
                //   label: orderStatus.DELIVERED,
                // }
              ]}
            />
            </div>
          </div>

          <div className='font-bold p-1 bg-slate-100 mt-2 border'>Additional Notes</div>
          <div className='grid gap-2 p-3 border'>
            {selectedOrder.note}
          </div>

          <div className='font-bold p-1 bg-slate-100 mt-2 border'>Order Items</div>
          <div className='grid gap-2 p-3 border'>
            {selectedOrder.orderItems?.map(item => {
              return (
                <div key={item.id}>{item.product.name} - Qty: {item.quantity} - Amount: LKR {item.quantity * item.price}</div>
              )
            })}
          </div>

          <div className='font-bold p-1 bg-slate-100 mt-2 border'>Payment Details</div>
          <div className='grid grid-cols-2 gap-2 p-3 border'>
            <div>Method</div><div>: {selectedOrder.payment?.method}</div>
            <div>Payment Status</div>
            <div>: <Select
              showSearch
              placeholder="Payment Status"
              optionFilterProp="label"
              value={selectedOrder.payment?.status}
              onChange={onChangePaymentStatus}
              // onSearch={onSearch}
              options={[
                {
                  value: paymentStatus.PENDING,
                  label: paymentStatus.PENDING,
                },
                {
                  value: paymentStatus.PAID,
                  label: paymentStatus.PAID,
                },
                {
                  value: paymentStatus.FAILED,
                  label: paymentStatus.FAILED,
                },
                {
                  value: paymentStatus.PROCESSING,
                  label: paymentStatus.PROCESSING,
                }
              ]}
            />
            </div>

            <div>Products Total (LKR)</div><div>:  {(selectedOrder.total + selectedOrder.discount - formatNumber(selectedOrder.shippingFee)).toFixed(2)}</div>
            <div>Shipping Fee (LKR)</div><div>: {formatNumber(selectedOrder.shippingFee).toFixed(2)}</div>
            <div>Discount (LKR)</div><div>: ({formatNumber(selectedOrder.discount).toFixed(2)})</div>
            <div>Net Total (LKR)</div><div>: {(selectedOrder?.total).toFixed(2)}</div>
          </div>

          <div className={`font-bold p-1 ${selectedOrder.isInternationalShipping ? 'bg-orange-400 text-white' : 'bg-slate-100'}  mt-2 border`}>Shipping Details {selectedOrder.isInternationalShipping && ("(GLOBAL)")}</div>
          <div className='grid grid-cols-2 gap-2 p-3 border'>
            <div>Address</div><div>: {selectedOrder.shipping?.address}</div>
            <div>Contact Number</div><div>: {selectedOrder.shipping?.telephone}</div>
            <div>City</div><div>: {selectedOrder.shipping?.city}</div>
            <div>Country</div><div>: {selectedOrder.shipping?.country}</div>
            <div>Shipping Provider</div><div>: {selectedOrder.shippingProvider}</div>
            {/* {selectedOrder.isInternationalShipping && (<><div>Tracking URL</div> */}
            <div>Shipping Tracking Number</div>
            <div> <Input value={selectedOrder.shipping?.trackingNumber} onChange={onChangeShippingTrackingNumber} /> </div>
            <div>Postal Code (ZIP)</div><div>: {selectedOrder.shipping?.zip}</div>
            <div>Shipping Label</div><div>: <Button onClick={() => setIsShippingLabelModalOpen(true)} type='primary'>Print</Button></div>
          </div>
          <div className='font-bold p-1 bg-slate-100 mt-2 border'>Billing Details</div>
          <div className='grid grid-cols-2 gap-2 p-3 border'>
            <div>Address</div><div>: {selectedOrder.billing?.address}</div>
            <div>Contact Number</div><div>: {selectedOrder.billing?.telephone}</div>
            <div>City</div><div>: {selectedOrder.billing?.city}</div>
            <div>Country</div><div>: {selectedOrder.billing?.country}</div>
            <div>Postal Code (ZIP)</div><div>: {selectedOrder.billing?.zip}</div>
          </div>
        </Modal>

      )}

      <ShippingLabel isShow={isShippingLabelModalOpen} setIsShow={setIsShippingLabelModalOpen} selectedOrder={selectedOrder} />
    </Row>
  );
}

export default AllOrders